/** Empty `teamIds` means "Everyone in the account" — not attached to any team. */
export const isScoringRuleAccountScoped = (teamIds: readonly number[] | undefined): boolean =>
    !teamIds || teamIds.length === 0;
